import React from 'react';
import { CheckCircle, Circle, ArrowRight } from 'lucide-react';

const steps = [
  { key: 'REQUESTED', label: 'Applied' },
  { key: 'TERMS', label: 'Terms' },
  { key: 'APPROVED', label: 'Approved' },
  { key: 'ACTIVE', label: 'Active' },
  { key: 'CLOSED', label: 'Closed' },
];

const getStepIndex = (status, termsStatus) => {
  if (status === 'CLOSED') return 4;
  if (status === 'APPROVED') return 3;
  if (status === 'REJECTED' || status === 'REVOKED') return -1;
  if (termsStatus === 'ACCEPTED' || termsStatus === 'PROPOSED' || termsStatus === 'COUNTERED') return 1;
  if (status === 'REQUESTED') return 0;
  return 0;
};

const RequestTimeline = ({ status, termsStatus, outcome }) => {
  const isRejected = status === 'REJECTED';
  const isRevoked = status === 'REVOKED';
  const isCancelled = isRejected || isRevoked;
  const currentStep = getStepIndex(status, termsStatus);

  if (isCancelled) {
    return (
      <div className="flex items-center gap-2 py-2" data-testid="request-timeline">
        <div className="flex items-center gap-1.5 px-3 py-1 rounded-lg bg-red-600/10 border border-red-600/20">
          <Circle className="w-3 h-3 text-red-500" />
          <span className="text-xs font-medium text-red-500">{status}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1 py-2 overflow-x-auto" data-testid="request-timeline">
      {steps.map((step, idx) => {
        const isCompleted = idx < currentStep;
        const isCurrent = idx === currentStep;
        const isFuture = idx > currentStep;

        return (
          <React.Fragment key={step.key}>
            <div className={`flex items-center gap-1 px-2.5 py-1 rounded-lg text-xs font-medium whitespace-nowrap ${
              isCompleted ? 'bg-green-600/10 text-green-400 border border-green-600/20' :
              isCurrent ? 'bg-brand-gold/10 text-brand-gold border border-brand-gold/30' :
              'bg-zinc-800/50 text-brand-muted border border-white/5'
            }`}>
              {isCompleted ? (
                <CheckCircle className="w-3 h-3" />
              ) : (
                <Circle className={`w-3 h-3 ${isCurrent ? 'text-brand-gold' : 'text-zinc-600'}`} />
              )}
              {step.label}
              {idx === 4 && outcome && (
                <span className={`ml-1 ${outcome === 'WON' ? 'text-green-400' : 'text-red-400'}`}>
                  ({outcome})
                </span>
              )}
            </div>
            {idx < steps.length - 1 && (
              <ArrowRight className={`w-3 h-3 flex-shrink-0 ${isCompleted ? 'text-green-600' : 'text-zinc-700'}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default RequestTimeline;
